import { lazy } from 'react';

export default function getAdditionalFieldComponent(country: string) {
  switch (country) {
    case 'bangladesh': {
      return lazy(() => import('@/countryModules/bangladesh/License/components/AdditionalField'));
    }

    default: {
      return lazy(() => import('./AdditionalField'));
    }
  }
}
